export const formatScheduledDeliveryDate = (scheduledDeliveryDate?: string | null) => {
    if (!scheduledDeliveryDate) {
        return null;
    }

    const date = new Date(scheduledDeliveryDate);

    if (Number.isNaN(date.getTime())) {
        return null;
    }

    // Format in UTC to avoid timezone drift (e.g., off-by-one day)
    return date.toISOString().slice(0, 10).replaceAll('-', '');
};

export const addScheduledDeliveryDateLabel = (fulfillmentMethod: string, scheduledDeliveryDate?: string | null) => {
    if (scheduledDeliveryDate) {
        return `${fulfillmentMethod} scheduled`;
    }

    return fulfillmentMethod;
};
